/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/site';

export const getMeterPoints =
	(): Promise<ApiResponse> => {
		return apiClient.get('/meter_points', {
			params: {
				pageSize: 100,
			},
		});
	};

export const useMeterPoints = () => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['meter_points'],
		queryFn: () => getMeterPoints(),
	});

	const updateList = (brands: any) =>
		brands.reduce((acc: any, currentItem: any) => {
			const modifiedItem = {
				...currentItem,
			};
			acc.push(modifiedItem);

			return acc;
		}, []);

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
